import MessageContainer from "./Message.container";

import Msg from "./Message";
import MessageSkeleton from "./MessageSkeleton";

export { Msg, MessageSkeleton, MessageContainer };

export default MessageContainer;
